export const HOME = {
  emergentLink: "home-emergent-link",
};

export const NAV = {
  logo: "nav-logo",
  home: "nav-link-home",
  about: "nav-link-about",
  puppies: "nav-link-puppies",
  videos: "nav-link-videos",
  reviews: "nav-link-reviews",
  enquireBtn: "nav-enquire-button",
  mobileMenuToggle: "nav-mobile-menu-toggle",
};

export const HERO = {
  section: "hero-section",
  ctaEnquire: "hero-cta-enquire",
  ctaWhatsapp: "hero-cta-whatsapp",
};

export const LEAD_MODAL = {
  dialog: "lead-capture-dialog",
  nameInput: "lead-capture-name-input",
  mobileInput: "lead-capture-mobile-input",
  submitBtn: "lead-capture-submit-button",
  closeBtn: "lead-capture-close-button",
};

export const REVIEW_MODAL = {
  dialog: "review-dialog",
  openBtn: "review-open-button",
  nameInput: "review-name-input",
  messageInput: "review-message-input",
  starButton: (n) => `review-star-${n}`,
  submitBtn: "review-submit-button",
};

export const SUGGESTION_MODAL = {
  dialog: "suggestion-dialog",
  openBtn: "suggestion-open-button",
  nameInput: "suggestion-name-input",
  messageInput: "suggestion-message-input",
  submitBtn: "suggestion-submit-button",
};

export const WHATSAPP = {
  fab: "whatsapp-fab-button",
};

export const VIDEO_GALLERY = {
  section: "video-gallery-section",
  card: (id) => `video-card-${id}`,
};

export const COMMUNITY_VIDEO_MODAL = {
  dialog: "community-video-dialog",
  openBtn: "community-video-open-button",
  petNameInput: "community-video-pet-name-input",
  ownerNameInput: "community-video-owner-name-input",
  mobileInput: "community-video-mobile-input",
  fileInput: "community-video-file-input",
  submitBtn: "community-video-submit-button",
};

export const STORY_MODAL = {
  dialog: "story-dialog",
  openBtn: "story-open-button",
  ownerNameInput: "story-owner-name-input",
  petNameInput: "story-pet-name-input",
  mobileInput: "story-mobile-input",
  storyInput: "story-message-input",
  submitBtn: "story-submit-button",
};

export const COMMUNITY_SECTION = {
  section: "community-section",
  uploadVideoBtn: "community-upload-video-button",
  writeStoryBtn: "community-write-story-button",
  videoCard: (id) => `community-video-card-${id}`,
  storyCard: (id) => `story-card-${id}`,
};

export const NEW_VIDEO_POPUP = {
  dialog: "new-video-popup-dialog",
  watchBtn: "new-video-popup-watch-button",
};

export const REVIEWS = {
  section: "reviews-section",
  card: (id) => `review-card-${id}`,
};

export const FOOTER = {
  section: "footer-section",
  whatsappBusiness: "footer-whatsapp-business",
  whatsappPersonal: "footer-whatsapp-personal",
  address: "footer-address",
};

export const ADMIN = {
  loginEmail: "admin-login-email-input",
  loginPassword: "admin-login-password-input",
  loginSubmit: "admin-login-submit-button",
  loginError: "admin-login-error",
  logoutBtn: "admin-logout-button",
  tabLeads: "admin-tab-leads",
  tabReviews: "admin-tab-reviews",
  tabSuggestions: "admin-tab-suggestions",
  tabVideos: "admin-tab-videos",
  videoTitleInput: "admin-video-title-input",
  videoDescriptionInput: "admin-video-description-input",
  videoThumbnailInput: "admin-video-thumbnail-input",
  videoFileInput: "admin-video-file-input",
  videoUploadBtn: "admin-video-upload-button",
  videoDeleteBtn: (id) => `admin-video-delete-${id}`,
  reviewApproveBtn: (id) => `admin-review-approve-${id}`,
  reviewDeleteBtn: (id) => `admin-review-delete-${id}`,
  tabCommunityVideos: "admin-tab-community-videos",
  tabStories: "admin-tab-stories",
  communityVideoDeleteBtn: (id) => `admin-community-video-delete-${id}`,
  storyApproveBtn: (id) => `admin-story-approve-${id}`,
  storyDeleteBtn: (id) => `admin-story-delete-${id}`,
  tabCareers: "admin-tab-careers",
  careerTitleInput: "admin-career-title-input",
  careerQualificationInput: "admin-career-qualification-input",
  careerSkillsInput: "admin-career-skills-input",
  careerEducationInput: "admin-career-education-input",
  careerPriceInput: "admin-career-price-input",
  careerFileInput: "admin-career-file-input",
  careerUploadBtn: "admin-career-upload-button",
  careerDeleteBtn: (id) => `admin-career-delete-${id}`,
};

export const CAREER_SECTION = {
  section: "career-section",
  card: (id) => `career-card-${id}`,
};

export const CAREER_DETAIL = {
  page: "career-detail-page",
  previewFrame: "career-preview-frame",
  payBtn: "career-pay-button",
  downloadBtn: "career-download-button",
  statusMsg: "career-payment-status",
};
